import React, { useState } from "react"
import { Card } from "react-bootstrap"
import moment from "moment"

import ReportTable from '../../../templates/ReportTable/ReportTable'
import useCallApi from "../../../hooks/useCallApi"
import Loading from "../../../templates/UI/Loading/Loading"
import WhitelistAddressModal from "./Components/WhitelistAddressModal"
import callAPI from "../../../helpers/callAPI"


export default function Whitelist({ showSystemMessage }) {
    document.title = 'Manage Whitelists'

    const { dataLoaded, data, refetch } = useCallApi(`compliance/whitelist`, 'GET', {}, [], showSystemMessage)
    const [isOpen, setIsOpen] = useState(false)
    const [deleteIndex, setDeleteIndex] = useState(-1)

    const deleteWhitelist = async (id) => {
        callAPI(`compliance/whitelist/${id}`, 'DELETE', {})
            .then(result => {
                if (result['success'] === true) {
                    showSystemMessage('success', result.message)
                    setDeleteIndex(-1)
                    refetch()
                } else {
                    showSystemMessage('error', result.errors.message)
                    setDeleteIndex(-1)
                }
            }).catch(error => {
                console.log(`Error while deleting whitelist address: ${error}`)
                showSystemMessage('error', 'An error occurred while deleting whitelist address.')
                setDeleteIndex(-1)
            })
    }

    const getReportOutput = () => {
        let columns = [
            {
                Header: 'Platform',
                accessor: 'payment_platform',
                Cell: ({ value }) => {
                    return <>{value}</>
                }
            },
            {
                Header: 'Street Address 1',
                accessor: 'street_address_1',
                Cell: ({ value }) => {
                    return <>{value}</>
                }
            },
            {
                Header: 'Street Address 2',
                accessor: 'street_address_2',
                Cell: ({ value }) => {
                    return <>{value}</>
                }
            },
            {
                Header: 'City',
                accessor: 'city',
                Cell: ({ value }) => {
                    return <>{value}</>
                }
            },
            {
                Header: 'State',
                accessor: 'state',
                Cell: ({ value }) => {
                    return <>{value}</>
                }
            },
            {
                Header: 'Country',
                accessor: 'country_code',
                Cell: ({ value }) => {
                    return <>{value}</>
                }
            },
            {
                Header: 'Zipcode',
                accessor: 'zip_code',
                Cell: ({ value }) => {
                    return <>{value}</>
                }
            },
            {
                Header: 'Purpose',
                accessor: 'purpose',
                Cell: ({ value }) => {
                    return <>{value}</>
                }
            },
            {
                Header: 'Date Added',
                accessor: 'db_date',
                Cell: ({ value }) => {
                    return <>{moment(value).utc().format('YYYY-MM-DD HH:mm:ss')}</>
                }
            },
            {
                Header: '',
                accessor: 'whitelists',
                Cell: (tableData) => {
                    let index = tableData.row.index
                    return (index === deleteIndex ? <button className="btn btn-danger btn-sm" onClick={() => deleteWhitelist(tableData.data[tableData.row.index].id)}>Confirm</button> : <button className="btn btn-sm btn-danger" onClick={() => setDeleteIndex(tableData.row.index)}>Delete</button>)
                }
            }
        ]

        return (
            <React.Fragment>
                <ReportTable data={data.whitelist} columns={columns} />
            </React.Fragment>
        )
    }

    return (
        <React.Fragment>
            <div className="page-header d-flex align-items-center justify-content-between">
                <h1 className="mb-h1">Manage Whitelists</h1>
            </div>

            <div className="row">
                {isOpen && <WhitelistAddressModal isOpen={isOpen} setIsOpen={setIsOpen} showSystemMessage={showSystemMessage} refetch={refetch} />}
                <div className="col-xl-8">
                    <Card>
                        <Card.Header>Address Whitelists
                            <button className="btn btn-sm btn-warning float-right" onClick={() => setIsOpen(true)}>Add Address</button>
                        </Card.Header>
                        {dataLoaded ? getReportOutput() : <Loading />}
                    </Card>
                </div>
            </div>
        </React.Fragment>
    )
}